<script lang="ts" setup>
import { ref } from 'vue'
import { contactUsConfig as rocnovelConfig } from './configs/rocnovel'
import { contactUsConfig as ocereadConfig } from './configs/oceread'
import { contactUsConfig as talewaveConfig } from './configs/talewave'
import { contactUsConfig as ficmoonConfig } from './configs/ficmoon'
import { contactUsConfig as novelarcConfig } from './configs/novelarc'
import { contactUsConfig as storyellaConfig } from './configs/storyella'
import { contactUsConfig as florastoryConfig } from './configs/florastory'
import { contactUsConfig as silktaleConfig } from './configs/silktale'
import { contactUsConfig as pearlaConfig } from './configs/pearla'
import { contactUsConfig as fictoraConfig } from './configs/fictora'
import { contactUsConfig as marinovelConfig } from './configs/marinovel'
import { contactUsConfig as flipnovelConfig } from './configs/flipnovel'
import { contactUsConfig as moonpageConfig } from './configs/moonpage'
import { contactUsConfig as storlynConfig } from './configs/storlyn'
import { contactUsConfig as novarisConfig } from './configs/novaris'
import ContactUsPageDefault from './components/ContactUsPage.default.vue'
import ContactUsPageFlipnovel from './components/ContactUsPage.flipnovel.vue'
import { api } from '@/api'
import { useToastStore } from '@/stores'
import { isValidEmail } from '@/utils'
import { loadBrandComponent, loadBrandConfig } from '@/utils/loadBrandConfig'

// 🔥 加载当前品牌配置（构建时 tree-shaking）
const config = loadBrandConfig({
  rocnovel: rocnovelConfig,
  oceread: ocereadConfig,
  talewave: talewaveConfig,
  ficmoon: ficmoonConfig,
  novelarc: novelarcConfig,
  storyella: storyellaConfig,
  florastory: florastoryConfig,
  silktale: silktaleConfig,
  pearla: pearlaConfig,
  fictora: fictoraConfig,
  marinovel: marinovelConfig,
  flipnovel: flipnovelConfig,
  moonpage: moonpageConfig,
  storlyn: storlynConfig,
  novaris: novarisConfig,
})

const ContactUsPage = loadBrandComponent({
  rocnovel: ContactUsPageDefault,
  oceread: ContactUsPageDefault,
  talewave: ContactUsPageDefault,
  ficmoon: ContactUsPageDefault,
  novelarc: ContactUsPageDefault,
  storyella: ContactUsPageDefault,
  florastory: ContactUsPageDefault,
  silktale: ContactUsPageDefault,
  pearla: ContactUsPageDefault,
  fictora: ContactUsPageDefault,
  marinovel: ContactUsPageDefault,
  flipnovel: ContactUsPageFlipnovel,
  moonpage: ContactUsPageFlipnovel,
  storlyn: ContactUsPageFlipnovel,
  novaris: ContactUsPageFlipnovel,
})

const { $toast } = useToastStore()

const des = ref('')
const email = ref('')
const loading = ref(false)

async function handleConfirm() {
  if (!isValidEmail(email.value)) {
    $toast(config.texts.emailErrorToast)
    return
  }

  loading.value = true

  try {
    const res = await api.post<PostIssueSubmitBody, PostIssueSubmitResponse>('/issue/submit', {
      issue: des.value,
      email: email.value,
    })

    if (res.code === 0 && res.data === true) {
      $toast(config.texts.successToast)
      des.value = ''
      email.value = ''
    }
    else {
      $toast(config.texts.failToast)
    }
  }
  catch (error: any) {
    $toast(error?.msg || config.texts.failToast)
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <ContactUsPage
    :config="config"
    :des="des"
    :email="email"
    :loading="loading"
    :handle-confirm="handleConfirm"
    @update:des="des = $event"
    @update:email="email = $event"
  />
</template>
